<template>
  <div class="ver-overlay" @click.self="$emit('close')">
    <div class="ver-modal">
      <h5>Версии набора</h5>
      <div class="ver-create">
        <input v-model="comment" type="text" class="form-control" placeholder="Комментарий к версии"/>
        <button class="btn btn-sm btn-primary" :disabled="busy" @click="createSnapshot">Сохранить версию</button>
      </div>
      <table class="table table-sm">
        <thead>
          <tr><th>Дата</th><th>Комментарий</th><th>Тип</th><th>Записей</th><th></th></tr>
        </thead>
        <tbody>
          <tr v-for="s in snapshots" :key="s.id">
            <td>{{ formatDate(s.createdAt) }}</td>
            <td>{{ s.comment }}</td>
            <td>{{ s.auto ? 'авто' : 'ручной' }}</td>
            <td>{{ s.recordsCount }}</td>
            <td class="ver-btns">
              <button class="btn btn-sm btn-outline-secondary" @click="download(s)">JSON</button>
              <button class="btn btn-sm btn-outline-danger" :disabled="busy" @click="restore(s)">Восстановить</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="result" class="text-success">{{ result }}</div>
      <div class="ver-actions">
        <button class="btn btn-outline-secondary" @click="$emit('close')">Закрыть</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  emits: ['close', 'restored'],
  data() {
    return {
      snapshots: [],
      comment: '',
      busy: false,
      result: '',
      hostApi: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'http://localhost:5001',
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    formatDate(iso) {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso || '-';
      return d.toLocaleString('ru-RU');
    },
    loadList() {
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/balansir/snapshot/list', {})
        .then(function (response) { vm.snapshots = response.data.data || []; })
        .catch(function (error) { console.log(error); alert('Ошибка загрузки версий'); });
    },
    createSnapshot() {
      let vm = this;
      vm.busy = true;
      axios.post(vm.hostApi + '/api/v1/balansir/snapshot/create', { comment: vm.comment || 'ручной снимок' })
        .then(function () {
          vm.comment = '';
          vm.result = 'Версия сохранена';
          vm.loadList();
        })
        .catch(function (error) { console.log(error); alert('Ошибка сохранения версии'); })
        .finally(function () { vm.busy = false; });
    },
    download(s) {
      let vm = this;
      axios.post(vm.hostApi + '/api/v1/balansir/snapshot/get', { snapshotId: s.id })
        .then(function (response) {
          const data = response.data.data;
          const blob = new Blob([JSON.stringify(data.records, null, 2)], { type: 'application/json' });
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'balansir_' + (data.createdAt || '').replace(/[:.]/g, '-') + '.json';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(a.href);
        })
        .catch(function (error) { console.log(error); alert('Ошибка загрузки снимка'); });
    },
    restore(s) {
      if (!window.confirm('Восстановить набор из версии от ' + this.formatDate(s.createdAt) +
        ' (' + s.recordsCount + ' записей)?\nТекущее состояние будет сохранено автоснимком.')) return;
      let vm = this;
      vm.busy = true;
      axios.post(vm.hostApi + '/api/v1/balansir/snapshot/restore', { snapshotId: s.id })
        .then(function (response) {
          vm.result = 'Восстановлено записей: ' + response.data.data.restored;
          vm.loadList();
          vm.$emit('restored');
        })
        .catch(function (error) { console.log(error); alert('Ошибка восстановления: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message)); })
        .finally(function () { vm.busy = false; });
    },
  },
};
</script>

<style scoped>
.ver-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.4); display: flex; align-items: center; justify-content: center; z-index: 1050; }
.ver-modal { background: var(--surface-1); color: var(--text-primary); border-radius: 6px; padding: 1.5em; width: 820px; max-width: 95vw; max-height: 85vh; overflow-y: auto; text-align: left; }
.ver-create { display: flex; gap: 0.5em; margin: 0.7em 0 1em 0; }
.ver-btns { display: flex; gap: 0.3em; }
.ver-actions { margin-top: 1em; text-align: right; }
</style>
